import { useNavigate, Navigate, useLocation } from "react-router-dom";
import "../styles/TeacherLatness.css";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  fetchTeacherInfo,
  sendTeacherLatness,
} from "../services/pms";
import { useLanguage } from "../context/LanguageContext";
import LoadingScreen from "../components/LoadingScreen";
import DenyAccessPage from "../components/DenyAccessPage";
import { TEACHER_LATENESS_ARABIC_TITLES, TEACHER_LATENESS_ENGLISH_TITLES, WISDOM_LATNESS_OPTIONS } from "../constants/constants";
import WisdomNavbar from "components/navbars/WisdomNabvar";
import { fetchWisdomRelatedSchools, fetchWisdomRelatedTeachers, fetchWisdomSubjects } from "services/wisdom/wisdomData";

function TeacherLatness() {
  const location = useLocation();
  const navigate = useNavigate();

  const { userInfo } = useAuth();
  const { language } = useLanguage();

  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [teachers, setTeachers] = useState([]);
  const [filteredTeachers, setFilteredTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const [schoolsResponse, subjectsResponse, teachersResponse] =
          await Promise.all([
            fetchWisdomRelatedSchools(),
            fetchWisdomSubjects(),
            fetchWisdomRelatedTeachers(),
          ]);

        setSchools(schoolsResponse);
        setSubjects(subjectsResponse);
        setFilteredSubjects(subjectsResponse);

        const filteredTeachers = teachersResponse.filter(
          (teacher) => teacher.id !== userInfo.id
        );

        const relatedUsers =
          (userInfo.user_role !== "Operations Excellence Lead" && userInfo.user_role !== "Super Admin")
            ? filteredTeachers.filter(
              (user) =>
                user.employee.organization_id === userInfo.organization_id
            )
            : teachersResponse;

        setTeachers(relatedUsers);
        setFilteredTeachers(relatedUsers);
      } catch (err) {
        console.error("API Error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [userInfo]);

  useEffect(() => {
    const loadTeacherInfo = async () => {
      try {
        const teacherData = {
          id: Number(selectedUserId?.employee?.user_id),
        };
        const response = await fetchTeacherInfo(teacherData);
        console.log(response)
        setSelectedTeacher(response);
      } catch (err) {
        console.error("API Error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadTeacherInfo();
  }, [selectedUserId]);

  useEffect(() => {
    const filterFilters = () => {
      const filteringSubjects = subjects.filter(subject => subject.organizations.find(org => org.id === Number(selectedSchool)));
      const filteringTeachers = teachers.filter(
        teacher =>
          (selectedSchool === "" ||
            teacher.employee.organization_id === Number(selectedSchool)) &&
          (selectedSubject === "" ||
            teacher.subjects.find(sub => sub.id === Number(selectedSubject)))
      );
      setFilteredSubjects(filteringSubjects);
      setFilteredTeachers(filteringTeachers);
    };

    filterFilters();
  }, [selectedSchool, selectedSubject, subjects, teachers]);

  const submitLatness = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const entries = Array.from(formData.entries());
    
    const latness = [];
    console.log(selectedTeacher)
    for (let [name, value] of entries) {
      if (name.includes(" ")) {
        const [classId] = name.split(" ");
        latness.push({
          teacher_id: Number(selectedTeacher?.employee?.teacher?.id),
          session_id: parseInt(classId),
          late: Number(value),
        });
      }
    }
    try {
      await sendTeacherLatness(latness);
      toast.success("Done");
      navigate("/pms");
    } catch (err) {
      toast.error("Please fill the data");
      console.error("Error submitting data:", err);
    }
  };

  if (loading) return <LoadingScreen />;
  if (error?.status === 403) return <Navigate to="/login" state={{ from: location }} replace />;
  if (error) return <p>Error: {error.message}</p>;
  if (userInfo.user_role !== "Operations Excellence Lead" && userInfo.user_role !== "Supervisor" && userInfo.user_role !== "Social Worker" && userInfo.user_role !== "Super Admin") return <DenyAccessPage homePage='/pms' />;
  if (userInfo?.code === 1452 || userInfo?.code === 1476) return <DenyAccessPage homePage='/watoms/dashboard' />;
  if (userInfo?.code === 1475) return <DenyAccessPage homePage='/watoms/news' />;
  if (userInfo?.code === 1310) return <DenyAccessPage homePage='/wisdom/dashboard' />;

  return (
    <div className="bg-formColor flex flex-col items-center gap-6 min-h-screen">
      <WisdomNavbar />
      <div className="w-full">
        <h1 className="text-2xl font-bold text-center">
          {language ? "Teacher Latness" : "تاخير المعلم"}
        </h1>
      </div>
      {/* School Filter */}
      {userInfo?.organization_id === 13 && <div className="flex flex-col justify-center items-center w-[99%]">
        <label>{language ? "School:" : ":المدرسة"}</label>
        <select id="school" name="school" onChange={e => setSelectedSchool(e.target.value)} >
          <option value="" disabled selected>
            {language ? "Please Select a School" : "الرجاء اختيار مدرسة"}
          </option>
          {schools.map((school) => (
            <option id={school.id} value={school.id} >{school.name}</option>
          ))}
        </select>
      </div>}
      {/* subjects Filter */}
      <div className="flex flex-col justify-center items-center w-[99%]">
        <label>{language ? "Subject:" : ":الماة"}</label>
        <select id="subject" name="subject" onChange={e => setSelectedSubject(e.target.value)} >
          <option value="" disabled selected>
            {language ? "Please Select a Subject" : "الرجاء اختيار المادة"}
          </option>
          {filteredSubjects.map((subject) => (
            <option id={subject.id} value={subject.id} >{subject.name}</option>
          ))}
        </select>
      </div>
      {/* Teacher Selector */}
      <div className="flex flex-col justify-center items-center w-[99%]">
        <label>{language ? "Teacher:" : ":المعلم"}</label>
        <select id="teacher" name="teacher" onChange={e => setSelectedUserId(teachers.find(t => t.employee?.id === Number(e.target.value)))} onClick={(e) => setSelectedTeacher(e.target.value)}>
          <option value="" disabled selected>
            {language ? "Please Select a Teacher" : "الرجاء اختيار المعلم"}
          </option>
          {filteredTeachers.map((teacher) => (
            <option
              key={teacher.employee?.id}
              value={teacher.employee?.id}
            >{`${teacher.employee?.first_name} ${teacher.employee?.middle_name} ${teacher.employee?.last_name}`}</option>
          ))}
        </select>
      </div>
      {selectedTeacher !== null ? (
        <form
          dir={language ? "ltr" : "rtl"}
          className="w-[92%] max-w-full min-w-0 self-center rounded-lg bg-white p-4 shadow-[0_4px_10px_rgba(0,0,0,0.1)] sm:w-[85%] md:w-[80%]"
          onSubmit={submitLatness}
        >
          {/* Scrollable table */}
          <p className="mb-2 text-center text-xs text-gray-400 sm:hidden">
            {language ? "Swipe to see all sessions →" : "◄ اسحب لرؤية جميع الحصص"}
          </p>
          <div className="w-full overflow-x-auto rounded-md border border-gray-200">
            <div className="w-max min-w-full">

              {/* Header */}
              <div className="grid w-max grid-cols-[140px_repeat(10,110px)] items-center border-b border-gray-200 bg-gray-50">
                {(language
                  ? TEACHER_LATENESS_ENGLISH_TITLES
                  : TEACHER_LATENESS_ARABIC_TITLES
                ).map((title, index) => (
                  <div
                    key={index}
                    className={`flex h-12 items-center justify-center border-r border-gray-200 bg-gray-50 px-2 text-center text-sm font-semibold text-gray-700 ${index === 0 ? "sticky start-0 z-20" : ""
                      }`}
                  >
                    {title}
                  </div>
                ))}
              </div>

              {/* Rows */}
              {selectedTeacher?.employee?.teacher?.sessions?.map((classes, index) => (
                <div
                  key={`${classes.id}-${index}`}
                  className="group grid grid-cols-[140px_repeat(10,110px)] items-center border-b border-gray-100 transition-colors hover:bg-gray-50"
                >
                  {/* Class */}
                  <div className="sticky start-0 z-10 flex min-h-14 items-center border-r border-gray-200 bg-white px-3 text-sm font-medium text-gray-800 group-hover:bg-gray-50">
                    {classes.class.name}
                  </div>

                  {/* Sessions */}
                  {[...Array(10)].map((_, sessionIndex) => (
                    <div
                      key={sessionIndex}
                      className="flex min-h-14 items-center justify-center border-r border-gray-200 px-1.5"
                    >
                      <select
                        className="w-full cursor-pointer rounded-md border border-gray-300 bg-white px-1 py-2 text-xs outline-none transition focus:border-wisdomOrange focus:ring-2 focus:ring-wisdomOrange/20 sm:text-sm"
                        name={`${classes.id} ${sessionIndex + 1}`}
                        defaultValue=""
                      >
                        <option value="" disabled>
                          {language ? "On Time" : "في الموعد"}
                        </option>

                        {WISDOM_LATNESS_OPTIONS.map((min) => (
                          <option key={min} value={min}>
                            {min} min.
                          </option>
                        ))}
                      </select>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Submit */}
          <div className="flex justify-center pt-5">
            <button
              type="submit"
              className="rounded-md bg-wisdomOrange px-6 py-2.5 font-medium text-white transition-colors hover:bg-wisdomDarkOrange focus:outline-none focus:ring-2 focus:ring-wisdomOrange/40"
            >
              {language ? "Submit" : "ارسال"}
            </button>
          </div>
        </form>
      ) : (
        <div className="noTeacher">Please Select a Teacher</div>
      )}
    </div>
  );
}

export default TeacherLatness;
